import { render, staticRenderFns } from "./TvListingsDialog.vue?vue&type=template&id=5e5877f4"
import script from "./TvListingsDialog.vue?vue&type=script&lang=js"
export * from "./TvListingsDialog.vue?vue&type=script&lang=js"
import style0 from "./TvListingsDialog.vue?vue&type=style&index=0&id=5e5877f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports